import { Component, Input, OnInit } from '@angular/core';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { Config } from 'src/app/config';
import { WidgetsTimeRangeModel } from '../../../models/widgets/widgets-time-range.model';
import { WidgetsRadioModel } from '../../../models/widgets/widgets-radio.model';
import { WidgetsFieldModel } from '../../../models/widgets/widgets-field.model';
import { WidgetsQuestionModel } from '../../../models/widgets/widgets-question.model';
import { WidgetsInputModel } from '../../../models/widgets/widgets-input.model';
import { WidgetsCheckboxModel } from '../../../models/widgets/widgets-checkbox.model';
import { WidgetsSectionModel } from '../../../models/widgets/widgets-section.model';
import { WidgetsFormModel } from '../../../models/widgets/widgets-form.model';
import { WidgetsClassEnum, WidgetsConfigController, WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { capitalize } from '@angular-devkit/core/src/utils/strings';
import { UserService } from 'src/app/core/user.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'appMetadataWidget',
  templateUrl: './metadata-widget.component.html',
  styleUrls: ['./metadata-widget.component.scss'],
})
export class MetadataWidgetComponent implements OnInit {
  @Input() data?: WidgetsAbstract;
  isFormIdEnabled: boolean = Config.GLOBALS.isFormIdEnabled;

  constructor(
    public userService: UserService   // Needed in template
    ) {
    // Empty
  }

  ngOnInit(): void {
    // Check permissions
    // { MayEdit: true, MayView: true, ResourceCategory: 'FDC', ResourceName: 'FB_Design_Forms' }
  }

  onSelect($event: any) {
    // const type = $event.target[$event.target.selectedIndex].dataset.type;
  }

  /**
   * @returns Generic name of the widget type
   */
  getType(): string {
    if ((this.data instanceof WidgetsAbstract)) {
      const name = WidgetsConfigController.get(this.data.widgetType);
      if (name && name.label) {
        return name.label;
      }
    }

    return 'widget';
  }

  getPrettyType() {
    return capitalize(this.getType());
  }
}
